import {FilterConverter} from "../filter/FilterConverter";
import {FiltersStateInitializer} from "../defaultInitializer/FiltersStateInitializer";
import {getAPIGatewayDataFromParent} from "../../handler/ParentDataHandler";
import {isINRegion, logOperationalMetric} from "../../util/CommonUtils";
import {getFeatureStatus, convertToValidPackageState} from "../CommonUtils";
import {FEATURES} from "../constants/CommonConstants";
import { DWELL_FILTER_ACTIONS } from "../constants/CommonConstants";


const metricProcessName = "SCC_PACKAGE_SEARCH";
export async function getPackageResults(filters, stationCode, view, leg, dispatcher,isCPTFilterEnabled, filterDispatcher, size) {

    var initializedFilters = FiltersStateInitializer(filters, [])
    var packageStatusMap = {}
    const modifiedRequest = await FilterConverter(initializedFilters, null, leg, packageStatusMap, null, filters.packageStatuses? filters.packageStatuses:  [], isCPTFilterEnabled);
    var lastUpdatedRange;
    const startTime = Date.now();
    var buyBackVisibilityEnabled = isINRegion() && await getFeatureStatus(FEATURES.IS_BUYBACK_VISIBILITY_FOR_AGEINGTAB_ENABLED);
    if (initializedFilters.lastUpdatedStart !== "" || initializedFilters.lastUpdatedEnd !== "") {
        lastUpdatedRange = {
            "startTime" : initializedFilters.lastUpdatedStart ? new Date(initializedFilters.lastUpdatedStart).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedEnd).getTime() - 24 * 60 * 60 * 1000) / 1000 ,
            "endTime": initializedFilters.lastUpdatedEnd ? new Date(initializedFilters.lastUpdatedEnd).getTime() / 1000 : (new Date(initializedFilters.lastUpdatedStart).getTime() + 24 * 60 * 60 * 1000) / 1000
        }  
    } 
    const startingIndex = 0;
    const requestBody = (size === undefined || size === "") ? 
        {
            "nodeId": stationCode,
            "packageStatusMap" : packageStatusMap,
            "filters": modifiedRequest,
            "lastUpdatedRange" : lastUpdatedRange,
        } :
        {
            "nodeId": stationCode,
            "packageStatusMap" : packageStatusMap,
            "filters": modifiedRequest,
            "lastUpdatedRange" : lastUpdatedRange,
            "size": size,
            "startingIndex": startingIndex
        }

    const request = {

        resourcePath: "/os/getDrillDownData",
        httpMethod: "post",
        processName: "oculus",
        requestBody: requestBody
    }

    const handleFilterDispatch = (packageResultList) => {
        if (filterDispatcher) {
            filterDispatcher({type: DWELL_FILTER_ACTIONS.RECEIVE_FILTER_DATA, data: { packageResultList }});
            filterDispatcher({type: DWELL_FILTER_ACTIONS.SELECT_PACKAGE_STATUS_TILE, selectedPackageStatusListTile: filters.packageStatuses || []});
        }
    };

    getAPIGatewayDataFromParent(request).then(result => {
        if (result.status === 200) {
            logOperationalMetric(startTime, metricProcessName, "getDrillDownData", true);
            dispatcher({type: "RECEIVED_DATA", data: {
                isLoading: false,
                packageResultList: convertToValidPackageState(result.data.packageResultList),
                addressFieldsEnabled: result.data.addressFieldsEnabled,
                buyBackVisibilityEnabled: buyBackVisibilityEnabled
            }});
            handleFilterDispatch(result.data.packageResultList);
        } else {
            logOperationalMetric(startTime, metricProcessName, "getDrillDownData", false);
            dispatcher({type: "RECEIVED_DATA", data: {
                isLoading: false,
                packageResultList: []
            }});
            handleFilterDispatch([]);
        }
    }).catch(() => {
        dispatcher({type: "RECEIVED_DATA", data: {
            isLoading: false,
            packageResultList: []
        }});
        handleFilterDispatch([]);
    });
}


// WEBPACK FOOTER //
// ./src/commons/api/GetDrillDownResults.js